import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserService } from 'app/users/shared/user.service';
import { GridDataResult, PageChangeEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { UtilService } from 'app/hrms/shared/util.service';
import { HRMSService } from 'app/hrms/shared/hrms.service';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';
import { DateService } from 'app/date/date.service';

@Component({
  selector: 'app-visa-expiry',
  templateUrl: './visa-expiry.component.html',
  styleUrls: ['./visa-expiry.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VisaExpiryComponent implements OnInit {
  employees:any;
  public pageSize = 10;
  public skip = 0;
  public gridView: GridDataResult;
  branches:any;
  designations:any;
  constructor(private userService:UserService, private util:UtilService, private hrmsService:HRMSService, private ls:LogisticsService, private dateService:DateService) { }

  ngOnInit() {
    this.getAllBranch();
    this.getAllDesignations();
    this.getAllEmployees();
  }
  getAllEmployees()
  {
    this.userService.getAllUser().snapshotChanges().subscribe((data)=>{
      this.employees = [];
      data.forEach((user)=>{
        if(user.payload.child("role").val() != 'customer' && user.payload.child("visaExpiryDate").exists())
        {
          //console.log("visa",this.util.getDayDifference(new Date(user.payload.child("visaExpiryDate").val()),new Date(this.dateService.getTodaysDate())),new Date(user.payload.child("visaExpiryDate").val()),new Date(this.dateService.getTodaysDate()));
          if(user.payload.child("visaExpiryDate").val() != '')
          {
            this.employees.push({
              "Id": user.key,
              "Name": String(user.payload.child("name").val()),
              "EmployeeId": String(user.payload.child("employeeId").val()),
              "Designation": this.designations[user.payload.child("designation").val()?user.payload.child("designation").val():null],
              "Branch": this.branches[user.payload.child("branch").val()],
              "Passport": user.payload.child("passportNumber").val(),
              "ExpiryDate": this.util.getFormatedDateFromFullDate(new Date(user.payload.child("visaExpiryDate").val())),
              "Days": this.util.getDayDifference(new Date(user.payload.child("visaExpiryDate").val()),new Date(this.dateService.getTodaysDate())),
              "Date": new Date(user.payload.child("visaExpiryDate").val()),
              "DocumentType": "visa"
            });
          }
          if(user.payload.child("iqamaExpiryDate").exists() && user.payload.child("iqamaExpiryDate").val() != '')
          {
            this.employees.push({
              "Id": user.key,
              "Name": String(user.payload.child("name").val()),
              "EmployeeId": String(user.payload.child("employeeId").val()),
              "Designation": this.designations[user.payload.child("designation").val()?user.payload.child("designation").val():null],
              "Branch": this.branches[user.payload.child("branch").val()],
              "Passport": user.payload.child("passportNumber").val(),
              "ExpiryDate": this.util.getFormatedDateFromFullDate(new Date(user.payload.child("iqamaExpiryDate").val())),
              "Days": this.util.getDayDifference(new Date(user.payload.child("iqamaExpiryDate").val()),new Date(this.dateService.getTodaysDate())),
              "Date": new Date(user.payload.child("iqamaExpiryDate").val()),
              "DocumentType": "iqama"
            });
          }  
        }
      });
      this.employees.sort(function(a,b){
        return a.Date.getTime() - b.Date.getTime();
        });
      this.loadItems();
  });
}
private loadItems():void{
  this.gridView = {
    data: this.employees.slice(this.skip, this.skip + this.pageSize),
    total: this.employees.length
  };
}

public getAllDesignations()
{
  var x = this.hrmsService.getAllDesignations();
  x.snapshotChanges().subscribe(item=>{
  this.designations = [];
    item.forEach(element =>{
        this.designations[element.key] = element.payload.child("name").val();
    });
  });
}
getAllBranch()
{
  this.ls.getBranch().snapshotChanges().subscribe(data=>{
    this.branches  = [];
    data.forEach(branch=>{
      this.branches[branch.key] = branch.payload.child("name").val();
    });
  });
}
public pageChange(event: PageChangeEvent): void {
  this.skip = event.skip;
  this.loadItems();
}
public rowCallback = (context: RowClassArgs) => {
  switch (context.dataItem.Days) {
    case 0:
    //console.log("true");
      return {gold : true};
    default:
      return {};
   }
 }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/overview/visa-expiry/visa-expiry.component.ts